import { Tag } from "@diametral/design-system/react";

import type { ComplianceStatus, MyProjectStatus, ProjectStatus, ReportStatus, RequestStatus } from "../api/types";
import {
  COMPLIANCE_STATUS,
  MY_STATUS,
  PROJECT_STATUS,
  REPORT_STATUS,
  REQUEST_STATUS,
  type Labelled,
} from "../lib/labels";

function ToneTag({ value }: { value: Labelled }) {
  return <Tag tone={value.tone}>{value.label}</Tag>;
}

export function ProjectStatusTag({ status }: { status: ProjectStatus }) {
  return <ToneTag value={PROJECT_STATUS[status]} />;
}

export function MyStatusTag({ status }: { status: MyProjectStatus }) {
  if (status === "none") return null;
  return <ToneTag value={MY_STATUS[status]} />;
}

export function RequestStatusTag({ status }: { status: RequestStatus }) {
  return <ToneTag value={REQUEST_STATUS[status]} />;
}

export function ReportStatusTag({ status }: { status: ReportStatus }) {
  return <ToneTag value={REPORT_STATUS[status]} />;
}

export function ComplianceStatusTag({ status }: { status: ComplianceStatus }) {
  return <ToneTag value={COMPLIANCE_STATUS[status]} />;
}
